const tabs = {
    actions: 'Actions',
    get_started: 'Commencez',
    dashboard: 'Tableau de bord',
    applications: 'Applications',
    api_resources: 'Ressources API',
    sign_in_experience: 'Connexion et compte',
    connectors: 'Connecteurs',
    enterprise_sso: "SSO d'entreprise",
    security: 'Sécurité',
    webhooks: 'Webhooks',
    organizations: 'Organisations',
    users: 'Gestion des utilisateurs',
    audit_logs: "Journaux d'audit",
    roles: 'Rôles',
    docs: 'Documentation',
    tenant_settings: 'Paramètres du locataire',
    mfa: 'Authentification multi-facteur',
    customize_jwt: 'Personnaliser JWT',
    signing_keys: 'Clés de signature',
    organization_template: "Modèle d'organisation",
};
export default Object.freeze(tabs);
